let observer: IntersectionObserver | null = null;

export function getRevealObserver(): IntersectionObserver | null {
  if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') return null;
  if (observer) return observer;
  observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-in', '');
          observer?.unobserve(entry.target);
        }
      }
    },
    { threshold: 0, rootMargin: '0px' },
  );
  return observer;
}

/**
 * Marks every [data-reveal] element that is already inside the viewport as
 * revealed. Call before adding `html.js`, so above-the-fold content stays
 * visible straight from the prerendered HTML instead of hiding then fading in.
 */
export function revealFirstViewport(): void {
  if (typeof document === 'undefined') return;
  const fold = window.innerHeight;
  for (const el of document.querySelectorAll('[data-reveal]')) {
    const rect = el.getBoundingClientRect();
    if (rect.top < fold && rect.bottom > 0) el.setAttribute('data-in', '');
  }
}

/**
 * Switches scroll reveals on: on-screen content is marked revealed, then
 * `html.js` starts hiding everything else until it scrolls in. Only call this
 * once hydration has committed (see RevealsAfterHydration): `data-in` on a
 * React-owned node the client render does not produce is a hydration attribute
 * mismatch. Until then nothing is hidden, so the prerendered page shows as-is.
 */
export function enableReveals(): void {
  if (typeof document === 'undefined') return;
  revealFirstViewport();
  document.documentElement.classList.add('js');
}
